export const SUCCESS_CONTENTREPO_LIST = "SUCCESS_CONTENTREPO_LIST";
export const LOADING_CONTENTREPO = "LOADING_CONTENTREPO";

export const RepoTypes = {
	SUCCESS_CONTENTREPO_LIST,
	LOADING_CONTENTREPO
}